import { createTheme } from '@mantine/core'

export const theme = createTheme({
  fontFamily: 'Outfit',
  // primaryColor: "red",
  // ... other theme override properties
})
